export default __webpack_public_path__ + "static/media/yt.adb6e552.svg";